
define('ldsh!modules/editor/templates/section_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<section class="ed-inner-wrapper js-section-elements"></section>\n';

}
return __p
};});

